// routes/generator.realtime.($mode).tsx
import { getI18n } from 'src/i18n/i18n.middleware'
import { createRedirect } from 'src/utils/router/route'
import { dynamic } from 'src/utils/ssr'
import { staticMeta, staticMetaLoader } from 'src/utils/ssr-meta/seo'
import type { Route } from './+types/generator.realtime.($mode)'

const getClientModule = () =>
  import('src/clientRoutes/generator.realtime.($mode)')

export const handle = {
  name: 'generator/realtime',
  track: { scene: 'realtime' },
  hideMembershipBanner: true,
}

export function loader({ request, context }: Route.LoaderArgs) {
  const { t } = getI18n(context)
  return staticMetaLoader({
    requestUrl: request.url,
    title: t('server:meta.home.title'),
  })
}

export function meta({ loaderData }: Route.MetaArgs) {
  return staticMeta(loaderData)
}

export async function clientLoader({
  request,
  params,
  serverLoader,
}: Route.ClientLoaderArgs) {
  if (params.mode !== 'drawing') {
    throw createRedirect(request, '/generator/realtime/drawing')
  }
  return serverLoader?.()
}
clientLoader.hydrate = true

export default dynamic(getClientModule, { ssr: false })
